import { Table } from "antd";
import Manage from "..";
import { useEffect, useState } from "react";
import DeleteBoooking from "./components/DeleteBoooking";
import CreateBooking from "./components/CreateBooking";
import ConfirmBooking from "./components/ConfirmBooking";
import Moment from "react-moment";
import { BsCheckSquare } from "react-icons/bs";
import Toastify from "toastify-js";
import fetchAllRequests from "../../../services/fetchAllRequests";
import { pusher } from "../../..";

export default function AllRequests() {
  const [createModal, setCreateModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selected, setSelected] = useState({});
  const [bookings, setBookings] = useState([]);

  const handleFetchBookings = async () => {
    const data = await fetchAllRequests();
    setBookings(data);
  };

  useEffect(() => {
    handleFetchBookings();
    const book = pusher.subscribe(`booking`);
    book.bind("sent", function (data: any) {
      handleFetchBookings();
      Toastify({
        text: `New Account Request`,
        duration: 3000,
        close: true,
        gravity: "top",
        position: "right",
        style: {
          background: "linear-gradient(to right, #00b09b, #96c93d)",
        },
        stopOnFocus: true,
        onClick: function () {},
      }).showToast();
    });

    return () => {
      pusher.unsubscribe("request");
    };
  }, []);

  const columns = [
    {
      title: "S/N",
      width: 60,
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">{index + 1}</span>
      ),
    },

    {
      title: "Customer",
      width: 180,
      render: (record: any) => (
        <div className="w-full">
          {record?.customer_code === 0 ? (
            <div className="text-gray-700 bg-red-200 p-2 w-full">
              <span className="mr-2"> Guest:</span>

              {record?.name === null ? "-" : record?.name}
            </div>
          ) : (
            <div className="p-2">
              {record?.name === null ? "-" : record?.name}
            </div>
          )}
        </div>
      ),
    },
    {
      title: "Requested",
      width: 150,
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.createdAt === null ? (
            "-"
          ) : (
            <Moment fromNow>{record?.createdAt}</Moment>
          )}
        </span>
      ),
    },
    {
      title: "Mobile",
      width: 100,
      render: (record: any) => (
        <span className="text-gray-700">{record?.mobile}</span>
      ),
    },
    {
      title: "Organization",
      width: 150,
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.organization ? record?.organization : "-"}
        </span>
      ),
    },
    {
      title: "Occupation",
      width: 150,
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.occupation ? record?.occupation : "-"}
        </span>
      ),
    },

    {
      title: "Status",
      width: 150,
      render: (record: any) => (
        <div className="flex">
          {record.isAttended ? (
            <button className="flex justify-center items-center ml-1 text-green-700 border rounded-md p-2 bg-green-100 hover:bg-green-200 cursor-not-allowed">
              <BsCheckSquare /> <span className="ml-1">Attended</span>
            </button>
          ) : (
            <button
              onClick={() => {
                setSelected({
                  ...record,
                });
                setConfirmModal(true);
              }}
              className="flex justify-center items-center text-red-700 border rounded-md p-2 bg-gray-100 hover:bg-gray-200 cursor-pointer"
            >
              <span className="ml-1">Not Attended </span>
            </button>
          )}
        </div>
      ),
    },
  ];

  return (
    <Manage
      title={"New Account"}
      subtitle={"Requests"}
      description={"List of recent account requests"}
      actions={<></>}
    >
      <div className="grid gap-x-0 grid-cols-12">
        <div className="col-span-12 sm:col-span-12 md:col-span-12">
          <Table
            columns={columns}
            dataSource={[]}
            size="small"
            pagination={{ pageSize: 20 }}
            scroll={{ y: 425 }}
            rowKey="id"
          />

          <CreateBooking
            isVisible={createModal}
            setCreateModal={setCreateModal}
          />

          <ConfirmBooking
            selected={selected}
            isVisible={confirmModal}
            setConfirmModal={setConfirmModal}
            handleFetchBookings={handleFetchBookings}
          />

          <DeleteBoooking
            selected={selected}
            isVisible={deleteModal}
            setDeleteModal={setDeleteModal}
          />
        </div>
      </div>
    </Manage>
  );
}
